import React, { useEffect } from 'react';
import classNames from 'classnames';
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

const Logo = ({ section }) => {
  const logo = 'https://res.cloudinary.com/dahddvlgy/image/upload/v1649627792/mad_wallet/images/logos/logo.png';

  useEffect(() => {
    gsap.registerPlugin(ScrollToPlugin);
  },[]);

    const scrollToTop = () => {
      gsap.to(window, { scrollTo: 0 });
    }

    let logoClass = classNames({
      'logo-link': section === 'header',
      'footer__logo--link': section === 'footer'
    })
    
  return (
    <button className={logoClass} onClick={scrollToTop}>
        <img src={logo} alt="our logo"/>
    </button>
  )
}

export default Logo
